<template>
  <div>
    <section class="pure-hero-bg text-center text-light pt-1 pb-1">
      <div class="container-sm">
        <div class="hero-copy">
          <h1 class="hero-title">
            Let's get your payment method up and running
          </h1>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "PaymentsHeader"
}
</script>

<style scoped>

</style>
